import { render, staticRenderFns } from "./BlockUser.vue?vue&type=template&id=3b13bfb8&"
import script from "./BlockUser.vue?vue&type=script&lang=js&"
export * from "./BlockUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockUser.vue?vue&type=style&index=0&id=3b13bfb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports